<crm-multi-select
  [filtersUiVersion]="filtersUiVersion"
  #multiSelectComponent
  [options]="auditors"
  [(selectedItems)]="_selected"
  (selectedItemsChange)="onSelectedChange($event)"
  (panelShow)="onShowPanel()"
  (panelHide)="onHidePanel()"
  (onFilter)="search($event.filter)"
  scrollHeight="300px"
  [sort]="customRequest ? 'name:string' : ''"
  [group]="true"
  [appendTo]="appendTo"
  [disabled]="disabled"
  [styleClass]="styleClass"
  [class]="class"
  optionValue="name">
  <ng-template
    #groupTemplate
    let-group="group">
    <div [ngClass]="itemStyleClass">
      {{ group.label }}
    </div>
  </ng-template>

  <ng-template
    #itemTemplate
    let-item="item">
    <div [ngClass]="itemStyleClass">
      {{ item.name }}
    </div>
  </ng-template>

  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-multi-select>
